module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration010.363d1bef.webp";